
/**
 *  \file:   JSControl.vue
 *  \brief   Replaces the 'old' Java JSControl interface
 *
 *  $Id: JSControl.vue,v 1.18 2018/08/01 10:52:03 jhc Exp $
 *
 */
<template>
  <div>
    <div class="JSControl">
      <div class="jsController-container" />
      <div id="target" />
    </div>
  </div>
</template>

<script>/* Mixins */
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import $ from 'jquery'
import * as iconsLib from '@/assets/javascript/Icons-lib'; // eslint-disable-line

export default {
  name: 'JSControl',
  components: {
  },
  mixins: [SocketHandler, LifeCycle],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    deviceData: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      ledAutoMode: null,
      deviceListData: undefined,
      serverInfo: 'Info:',
      showAboutModal: false,
      componentName: '',
      ctrlFamily: 'TWC',
      ctrlType: 'TWC',
      ctrlModeAuto: true,
      DispLine1: 'Welcome to the Virtual Controller',
      DispLine2: '  ...  waiting for connection',
      forceClose: false,
      info_line1: '',
      info_line2: '',
      info_line3: '',
      blink: true,
      blinkTimeout: null,
      gone: false,
      ledson: [],
      ledsblink: 0,
      uparr: '|',
      dnarr: '|',
      device: null,
      deviceDescription: '',
      deviceSelected: 0,
      deviceInFocus: false,
      lastbutton: '',
      ledId2RKDName: [
        'jc-led-station',
        'jc-led-program',
        'jc-led-actpass',
        'jc-led-waterbudget',
        'jc-led-starttime',
        'jc-led-waterdays',
        'jc-led-runtime',
        'jc-led-pauseres',
        'jc-led-dial-advanced',
        'jc-led-dial-setup',
        'jc-led-dial-program',
        'jc-led-dial-auto',
        'jc-led-dial-manual',
        'jc-led-dial-irroff',
        'jc-led-dial-advanced'
      ],
      ledId2TWCName: [
        'jc-led-actpass',
        'jc-led-starttime', //  1
        'jc-led-dial-manual', //  2
        'jc-led-runtime', //  3
        'jc-led-station', //  4
        'jc-led-program', //  5
        'jc-led-waterbudget', //  6
        'jc-led-pauseres',
        'jc-led-waterdays', //  8
        'jc-led-dial-auto', //  9
        '', // Minus
        '', // OK
        'jc-led-dial-irroff', // 12
        'jc-led-dial-program', // 13
        'jc-led-dial-setup', // 14
        '' // Advanced
      ],
      ledId2GTCName: [
        'jc-led-dial-auto',
        'jc-led-set_datetime',
        'jc-led-dial-program',
        'jc-led-runtime',
        'jc-led-waterdays',
        'jc-led-starttime',
        'jc-led-waterbudget',
        'jc-led-actpass',
        'jc-led-dial-advanced',
        'jc-led-twowire',
        'jc-led-decoder',
        'jc-led-solenoid',
        'jc-led-setup_sensors',
        'jc-led-view_moisture',
        'jc-led-view_et',
        'jc-led-view_alarms',
        'jc-led-rain_event_status',
        'jc-led-rain_off',
        'jc-led-dial-irroff',
        'jc-led-dial-manual',
        'jc-led-pauseres',
        'jc-led-station',
        'jc-led-program',
        'jc-led-dial-setup'
      ],
      ledIds: []
    }
  },
  watch: {
    PageMessage(msg) {
      if(msg.target === 'jscontrol-open-dialogue-modal-Ignore') {
        this.forceClose = true
        this.$emit('CloseModal')
      }
    },
    SocketMessage(Message) {
      try {
        if(Message.data.category === 'server' && Message.data.command === 'info' && Message.data.data && Message.data.data.text) {
          this.serverInfo = `${this.$t('messages.jsControl.info')}: ${Message.data.data.text}`
          if(this.info_line3) {
            this.info_line3.textContent = this.serverInfo
          }
        } else if(Message.data.category === 'device' && Message.data.command === 'set') {
          if(Message.data.data && Message.data.data.type === 'display' && Message.data.data.status === 'off') {
            this.$router.push('/home')
          }
        } else if(Message.data.category === 'device' && Message.data.command === 'get') {
          if(Message.data.data && Message.data.data.type === 'display') {
            var displayLine1 = document.getElementById('displine1')
            var displayLine2 = document.getElementById('displine2')

            this.ledson = Message.data.data.ledson
            // this.setLeds( true )
            this.ledsblink = Message.data.data.ledsblink
            var uarr = String.fromCharCode(0xc0)
            var darr = String.fromCharCode(0xc1)
            var larr = String.fromCharCode(0x7f)
            var rarr = String.fromCharCode(0x7e)
            var str = Message.data.data.data

            while(str.indexOf(uarr) >= 0) {
              str = str.replace(uarr, '&uarr;')
            }
            while(str.indexOf(darr) >= 0) {
              str = str.replace(darr, '&darr;')
            }

            str = this.decodeHtml(str)
            var cursPos = Message.data.data.cursor
            var ledId2Name = this.ctrlType === 'TWC' ? this.ledId2TWCName : this.ledId2RKDName
            if(this.ctrlType === 'GTC') {
              ledId2Name = this.ledId2GTCName
            }
            var i
            // if(this.ledson !== undefined) {  // pointless if console logging is commented out eh?
            //   for(i = 0;i < this.ledson.length;i++) {
            //     // console.log('Leds on: ' + this.ledson[i] + ', ' + ledId2Name[ this.ledson[i] ])
            //   }
            // }
            var offs = 0 // cursPos < 40 ? 7 : 0;
            var offs2 = 0 // cursPos < 80 ? 7 : 0;

            var str1 = str.substring(0, 40 + offs)
            while(str1.indexOf(larr) >= 0) {
              str1 = str1.replace(larr, '<')
            }
            while(str1.indexOf(rarr) >= 0) {
              str1 = str1.replace(rarr, '>')
            }
            // line 1
            if(cursPos < 40) {
              var wrapperDisplayLine1 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan')

              // Text before cursor
              var txtSpan1 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan')
              txtSpan1.textContent = str1.substring(0, cursPos)

              // Text with underline (cursor)
              var txtSpan2 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan')
              txtSpan2.textContent = str1.substring(cursPos, cursPos + 1)
              txtSpan2.setAttribute('style', 'text-decoration:underline')

              // Text after cursor
              var txtSpan3 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan')
              txtSpan3.textContent = str1.substring(cursPos + 1)

              wrapperDisplayLine1.appendChild(txtSpan1)
              wrapperDisplayLine1.appendChild(txtSpan2)
              wrapperDisplayLine1.appendChild(txtSpan3)

              // concatenates the child nodes into one
              wrapperDisplayLine1.normalize()

              // clear out old SVG display content
              while(displayLine1.firstChild) {
                displayLine1.removeChild(displayLine1.firstChild)
              }
              displayLine1.appendChild(wrapperDisplayLine1)
            } else {
              displayLine1.textContent = str1
            }

            var str2 = str.substring(40 + offs, 80 + offs2)

            while(str2.indexOf(larr) >= 0) {
              str2 = str2.replace(larr, '<')
            }
            while(str2.indexOf(rarr) >= 0) {
              str2 = str2.replace(rarr, '>')
            }
            // line 2
            if(cursPos >= 40) {
              cursPos -= 40
              if(cursPos < str2.length) {
                var wrapperDisplayLine2 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan')

                // Text before cursor
                var txtSpan4 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan')
                txtSpan4.textContent = str2.substring(0, cursPos)

                // Text with underline (cursor)
                var txtSpan5 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan')
                txtSpan5.textContent = str2.substring(cursPos, cursPos + 1)
                txtSpan5.setAttribute('style', 'text-decoration:underline')

                // Text after cursor
                var txtSpan6 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan')
                txtSpan6.textContent = str2.substring(cursPos + 1)

                wrapperDisplayLine2.appendChild(txtSpan4)
                wrapperDisplayLine2.appendChild(txtSpan5)
                wrapperDisplayLine2.appendChild(txtSpan6)

                // concatenates the child nodes into one
                wrapperDisplayLine2.normalize()

                // clear out old SVG objects
                while(displayLine2.firstChild) {
                  displayLine2.removeChild(displayLine2.firstChild)
                }
                displayLine2.appendChild(wrapperDisplayLine2)
              } else {
                displayLine2.textContent = str2
              }
            } else {
              displayLine2.textContent = str2
            }
          }
        } else {
          // spinner.spin();
          // $('.spinner').show();
        }
        // spinner.stop();
        // $('.spinner').hide();
      } catch(err) {
        console.error('whoops! error found in JSControl.vue -> SocketMessage:', err)
      }
    },
    clearInfoDisplay() {
      this.serverInfo = ''
    }
  },

  mounted() {
    var self = this
    this.uparr = this.decodeHtml('&uarr')
    this.dnarr = this.decodeHtml('&darr')

    this.ledAutoMode = {}
    this.ledAutoMode['RKx'] = 11
    this.ledAutoMode['TWC'] = 9
    this.ledAutoMode['GTC'] = 0

    if(this.ModalData.data !== undefined) {
      this.deviceListData = this.ModalData.data
      this.deviceSelected = this.deviceListData.ctrlid  // was missing from deselect return message - jimm 2022.july.06
      this.deviceDescription = this.deviceListData.devDescription
      this.controllerType = this.deviceListData.controllerType
    } else if(this.deviceData !== undefined) {
      this.deviceListData = this.deviceData
      this.deviceDescription = this.deviceListData.devDescription
      this.controllerType = this.deviceListData.controllerType
    }
    if(this.controllerType !== undefined) {
      if(this.controllerType === 'AIC' ||
        this.controllerType.indexOf('TWC') >= 0 ||
        this.controllerType === 'RKS' ||
        this.controllerType === 'RKD' ||
        this.controllerType === 'RKD-O') {
        this.ctrlFamily = 'TWC'
        if(this.controllerType === 'AIC' || this.controllerType.indexOf('TWC') >= 0) {
          this.ctrlType = 'TWC'
        } else {
          this.ctrlType = 'RKx'
        }
      }
      if(this.controllerType.indexOf('GTC') >= 0 ||
        this.controllerType.indexOf('NLC') >= 0 ||
        this.controllerType.indexOf('PLUS') >= 0 ||
        this.controllerType.indexOf('LTD') >= 0 ||
        this.controllerType.indexOf('RAN') >= 0 ||
        this.controllerType.indexOf('SRC-RKD-PLUS') >= 0) {
        this.ctrlFamily = 'GTC'
        this.ctrlType = 'GTC'
      }
      var foil
      var hotspot
      if(this.controllerType !== undefined) {
        foil = iconsLib.getDeviceGraphic(this, 'foil', this.ModalData.data.typename)
        hotspot = iconsLib.getDeviceGraphic(this, 'hotspots', this.ModalData.data.typename)
      }
      var username = this.store.getData('user.first_name').trim() + ' ' + this.store.getData('user.last_name').trim()

       $('.jsController-container').append($('<div>'))
      // updated with vanilla appendChild - jimm 03.aug.2019
     // document.body.appendChild(document.createElement('<div>'))
      
      $('.jsController-container > div').load(hotspot, null, function() {
        // replace image with requested controller
        $(self.$el).find('#faceplate').get(0).setAttributeNS('http://www.w3.org/1999/xlink', 'href', foil)
        
        // remove extra stuff depending on controller name
        if(self.controllerType === 'AIC' || self.controllerType.indexOf('TWC') >= 0) {
          $('#key_twowire, .led_advanced, #dial_advanced').remove()
          // vanillaJS version of above
          // currently safer than using ES6 elem.remove() as IE 9 and less would need a polyfill -jimm 08.Aug.2019
          // var key_twowire = document.querySelector('#key_twowire')
          // key_twowire.parentNode.removeChild(key_twowire)   

          // var led_advanced = document.querySelector('.led_advanced')
          // led_advanced.parentNode.removeChild(led_advanced)           
          
          // var dial_advanced = document.querySelector('#dial_advanced')
          // dial_advanced.parentNode.removeChild(dial_advanced) 
        }
        
        if(self.controllerType.indexOf('-S') >= 0 || self.controllerType.indexOf('RKS-PLUS') >= 0) {
          $('#key_advanced, #key_decoder, #jc-led-decoder, #jc-led-twowire').remove()
          // var key_advanced = document.querySelector('#key_advanced')
          // key_advanced.parentNode.removeChild(key_advanced) 
          
          // var key_decoder = document.querySelector('#key_decoder')
          // key_decoder.parentNode.removeChild(key_decoder) 
          
          // var jc_led_decoder = document.querySelector('#jc-led-decoder')
          // jc_led_decoder.parentNode.removeChild(jc_led_decoder)           
          
          // var jc_led_twowire = document.querySelector('#jc-led-twowire')
          // jc_led_twowire.parentNode.removeChild(jc_led_twowire)  
        }

        // generate array of LED names
        this.ledIds = $('circle').map(function(index) {
          return this.id
        })

        // setup click event listener to parse dial and button/key requests
        $('rect, polygon').click(function(event) {
          // split id into prefix and actual target name for control functions
          var eventTargetId = event.target.id
          var control = eventTargetId.split(/_(.+)/)[0]
          var target = eventTargetId.split(/_(.+)/)[1]
          if(control === 'dial') {
            // send dial name
            self.jcDialClick(target)
          } else {
            // send button/key name
            self.jcButtClick(target)
          }
        })
        self.info_line1 = document.getElementById('infoline1')
        self.info_line2 = document.getElementById('infoline2')
        self.info_line3 = document.getElementById('infoline3')
        self.info_line1.textContent = `${self.$t('messages.jsControl.description')}: ${self.deviceDescription}`
        // self.info_line2.textContent = 'USER: ' + self.deviceListData.userid
        self.info_line2.textContent = `${self.$t('messages.jsControl.user')}: ${username} (${self.deviceListData.userid})`
        self.info_line3.textContent = self.$t('messages.jsControl.info')
      })
      if(this.deviceInFocus === true) {
        this.deviceInFocus = false
      }
      if(sessionStorage.getItem('route') !== this.$router.currentRoute.path) {
        sessionStorage.setItem('route', this.$router.currentRoute.path)
      }
      this.gone = false
    }
    this.blinkTimeout = setTimeout(
      () => {
        this.blinkon()
      }, 1000
    )
  },
  destroyed() {
    this.SocketMessageSend({component: 'JSControl', command: 'destroyed'})
    if(this.blinkTimeout) {
      clearTimeout(this.blinkTimeout)
    }
    this.gone = true

    if(window.deviceSelected) {
      this.SocketMessageSend({
        category: 'server',
        command: 'deselect',
        data: {
          type: 'device',
          item: this.deviceSelected
        }
      })
    }
    this.deviceSelected = null
  },
  methods: {

    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    jcDialClick(button) {
      this.SocketMessageSend({'category': 'device',
        'command': 'set',
        'data':
        {
          'type': 'dial',
          'item': button,
          'lastitem': ''
        }
      })

      /*  this.SocketMessageSend({'category': 'device',
        'command': 'set',
        'data': {
          'type': 'key',
          'item': 'cancel',
          'lastitem': ''
        }
      }); */

      // console.log('dial clicked: ' + button);
      // console.log('last dial clicked: ' + this.lastbutton);

      // store this dial click in lastbutton, for next time  -jimm/thai 14.03.2017
      this.lastbutton = button
    },
    jcButtClick(button) {
      this.SocketMessageSend({'category': 'device',
        'command': 'set',
        'data': {
          'type': 'key',
          'item': button,
          'lastitem': this.lastbutton
        }})

      // console.log('button clicked: ' + button);
      // console.log('last button clicked: ' + this.lastbutton);

      // store this button click in lastbutton, for next time  -jimm/thai 14.03.2017
      this.lastbutton = button
    },
    deviceList() {
      this.$router.push('/devicelist')
    },
    setLeds(onoff) {
      var i
      var led
      var ledId2Name = this.ctrlType === 'TWC' ? this.ledId2TWCName : this.ledId2RKDName
      if(this.ctrlType === 'GTC') {
        ledId2Name = this.ledId2GTCName
      }
      // Clear all LEDs
      if(ledId2Name !== undefined) {
        for(i = 0;i < ledId2Name.length;i++) {
          led = document.getElementById(ledId2Name[ i ])
          if(led) {
            led.style.opacity = '0.1'
          }
        }
      }
      // Light up all LEDs on
      if(this.ledson !== undefined) {
        for(i = 0;i < this.ledson.length;i++) {
          led = document.getElementById(ledId2Name[ this.ledson[i] ])
          if(led) {
            led.style.opacity = '1'
          }
        }
      }
      // Blink with all LEDs blinking
      if(this.ledsblink !== undefined) {
        for(i = 0;i < this.ledsblink.length;i++) {
          led = document.getElementById(ledId2Name[ this.ledsblink[i] ])
          if(led) {
            if(onoff) {
              led.style.opacity = '1'
            } else {
              led.style.opacity = '0.1'
            }
          }
        }
      }
    },
    blinkon() {
      this.setLeds(false)
      if(!this.gone) {
        this.blinkTimeout = setTimeout(() => {
          this.blinkoff()
        }, 500)
      }
    },
    blinkoff() {
      this.setLeds(true)
      if(!this.gone) {
        this.blinkTimeout = setTimeout(() => {
          this.blinkon()
        }, 500)
      }
    },
    decodeHtml(html) {
      var txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    },
    focusOnDevice() {
      // Set the device in focus on different devices
      if(this.deviceInFocus === false) {
        this.deviceInFocus = true
        document.getElementById('target').scrollIntoView()
      }
    },
    canModalClose() {
      let rtnBool = true
      if(this.forceClose) {
        return rtnBool
      }

      const getAutoMode = this.ledAutoMode[this.ctrlType]
      const containsAutoMode = this.ledson.filter(led => led === this.ledAutoMode[this.ctrlType]).length

      if(getAutoMode !== undefined) {
        if(!containsAutoMode) {
          rtnBool = false
          //window.alert('Please make sure the controller is in Auto');
          this.$emit('SetPageMessage', {
            target: 'ShowModal',
            modalData: {
              component: 'DialogueModal',
              data: {
                title: 'Virtual Controller',
                text: 'Please ensure the controller mode is set to \'AUTO\' before leaving the Virtual Controller.',
                prefix: 'jscontrol-open-dialogue-modal-',
                options: [
                  {label: 'Ignore', value: 'Ignore'}, {label: 'Return', value: 'Return'}
                ]
              }
            }
          })
        }
      } else {
        throw(Error('automode not set'))
      }

      return rtnBool
    },
    dollar(selector) {
      // vanilla replacement for jQuery's $().whatever using querySelector -jimm 09.aug.2019
      return document.querySelector(selector)
    }
  }
}
</script>

<style lang="scss">
.JSControl {
  margin: 0 auto;
}

.serverInfo {
  clear: both;
}

div.jsController-container {
  display: block;
  clear: both;
  margin: 0 auto;
  padding: 0;
  width: 90vw;
}

.gtc {
  top: 20%;
  left: 24%;
}

pre {
  border: 0 none;
  background-color: transparent;
}

.scaling-svg {
  position: relative;
  left: 0;
  top: 0;
}

.svg-content {
  display: inline-block;
  position: absolute;
  width: 100%;
  height: 100%;
}

text#infoline1, text#infoline2, text#infoline3 {
  white-space: pre;
  font-family: Arial, Verdana, sans-serif;
  font-family: $font-primary-semibold;
  font-stretch: ultra-expanded;
  letter-spacing: 0.07em;
  font-size: 0.65em;
}

text#displine1, text#displine2 {
  white-space: pre;
  font-family: "Courier New", Courier, monospace;
  font-size: 1.345em;
}
</style>
